/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { create } from 'zustand'

export type AuthModalView = 'sign-in' | 'sign-up' | 'forgot-password'

interface AuthModalState {
    open: boolean
    view: AuthModalView
    setOpen: (open: boolean) => void
    setView: (view: AuthModalView) => void
    openSignIn: () => void
    openSignUp: () => void
    openForgotPassword: () => void
}

export const useAuthModalStore = create<AuthModalState>((set) => ({
    open: false,
    view: 'sign-in',
    setOpen: (open) => set({ open }),
    setView: (view) => set({ view }),
    openSignIn: () => set({ open: true, view: 'sign-in' }),
    openSignUp: () => set({ open: true, view: 'sign-up' }),
    openForgotPassword: () => set({ open: true, view: 'forgot-password' }),
}))
